import {
    Box,
    Button,
    Grid,
    IconButton,
    Theme,
    Typography,
} from "@mui/material";
import { useState } from "react";
import {
    DownwardToggleBlueIcon,
    FundTransferArrow,
    UpwardToggleBlueIcon
} from "../../../../assets/SvgIcons";
import { ColorMap } from "../../types";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";
import { USER_ROLES } from "../../../../utils/constant";
import { RecommendationInfoCardProps } from "./types";
import { checkImageExists, isModuleAllowed } from "../../../../utils/utilityFunctions";
import { Notes } from "../../../investors/components";

const colorMap: ColorMap = {
    "low risk": "success.500",
    "high risk": "error.500",
    "moderate": "warning.500"
}

export default function RecommendationInfoCard({
    timeLeft,
    fromSchemeImg,
    toSchemeImg,
    recommendationDetails,
    handleAddToCartClick,
    ...props
}: RecommendationInfoCardProps): JSX.Element {
    const [toggleShowMore, setToggleShowMore] = useState<boolean>(false);

    const { role = '', permissions = [] } = useSelector((store: RootStateType) => store.auth);
    const filterlabel = recommendationDetails.filter((obj) => {
        // Remove "No. of Installments" if sipUntilCancelFlag is "Y" and buySellType is "XSIP"
        if (props.sipUntilCancelFlag === "Y" && props.buySellType === "XSIP" && obj.label === "No. of Installments") {
            return false;
        }
        return true;
    })
    const visibleDetails = filterlabel.slice(0, 4)
    const showMoreDetails = filterlabel.slice(4)

    const handleShowMoreToggle = () => {
        setToggleShowMore(prevState => !prevState)
    }

    return (
        <Box sx={{ marginBottom: "35px" }}>
            <Box
                sx={(theme: Theme) => ({
                    padding: '25px',
                    background: theme.palette.grey[50],
                    display: "flex",
                    justifyContent: "space-between"
                })}>
                <Box>
                    {!Number.isNaN(timeLeft) && timeLeft >= 0 && (
                        <Box
                            sx={(theme: Theme) => ({
                                display: "inline-block",
                                padding: '3px 10px',
                                background: theme.palette.warning[500],
                                borderRadius: '30px',
                                marginBottom: '5px',
                            })}
                        >
                            <Typography
                                variant="subtitle_600"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.textDark.primary
                                })}
                            >
                                {timeLeft === 0 && 'Expires today!!'}
                                {timeLeft > 0 && `${timeLeft} day${timeLeft > 1 ? 's' : ''} left`}
                            </Typography>
                        </Box>
                    )}
                    <Grid
                        container
                        sx={{
                            alignItems: 'center',
                            columnGap: "55px",
                            rowGap: "20px",
                            flexWrap: "wrap"
                        }}>
                        <Grid
                            item
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                columnGap: "15px",
                            }}
                        >
                            <Box
                                component="img"
                                src={checkImageExists(`${props?.amcId}`) ? `../../../../../../images/amcIcons/${props.amcId}.svg` : `../../../../../../images/amcIcons/default.svg`}
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '8px',
                                    objectFit: "contain"
                                }}
                                alt={props.fromSchemeName}
                            />
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "3px"
                                }}
                            >
                                <Typography
                                    variant="body_600"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                    })}
                                >
                                    {props.fromSchemeName}
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        columnGap: "8px",
                                    }}
                                >
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            color: theme.palette.text.secondary
                                        })}
                                    >
                                        {props.fromSchemeCategory}
                                    </Typography>
                                    <Box
                                        sx={{
                                            width: "3px",
                                            height: "3px",
                                            backgroundColor: "text.secondary",
                                            alignSelf: "center",
                                            borderRadius: "50%",
                                            marginTop: "4px"
                                        }}
                                    />
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            color: theme.palette.text.secondary
                                        })}
                                    >
                                        {props.fromSchemeSubCategory}
                                    </Typography>
                                    {!!props.fromSchemeRisk && props.fromSchemeRisk.toLowerCase() !== "null" && (
                                        <>
                                            <Box
                                                sx={{
                                                    width: "3px",
                                                    height: "3px",
                                                    backgroundColor: colorMap[props.fromSchemeRisk.toLowerCase()],
                                                    alignSelf: "center",
                                                    borderRadius: "50%",
                                                    marginTop: "4px"
                                                }}
                                            />
                                            <Typography
                                                variant="body_500"
                                                sx={{ color: colorMap[props.fromSchemeRisk.toLowerCase()] }}
                                            >
                                                {props.fromSchemeRisk}
                                            </Typography>
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </Grid >
                        {!!props.toSchemeName && (
                            <>
                                <Grid item>
                                    <FundTransferArrow />
                                </Grid>
                                <Grid item>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            columnGap: "15px",
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={checkImageExists(`${props?.amcId}`) ? `../../../../../../images/amcIcons/${props.amcId}.svg` : `../../../../../../images/amcIcons/default.svg`}
                                            sx={{
                                                width: '50px',
                                                height: '50px',
                                                borderRadius: '8px',
                                                objectFit: "contain"
                                            }}
                                            alt={props.toSchemeName}
                                        />
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                rowGap: "3px"
                                            }}
                                        >
                                            <Typography
                                                variant="body_600"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.text.primary,
                                                })}
                                            >
                                                {props.toSchemeName}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    columnGap: "8px",
                                                }}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    {props.toSchemeCategory}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        width: "3px",
                                                        height: "3px",
                                                        backgroundColor: "text.secondary",
                                                        alignSelf: "center",
                                                        borderRadius: "50%",
                                                        marginTop: "4px"
                                                    }}
                                                />
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    {props.toSchemeSubCategory}
                                                </Typography>
                                                {!!props.toSchemeRisk && props.toSchemeRisk.toLowerCase() !== "null" && (
                                                    <>
                                                        <Box
                                                            sx={{
                                                                width: "3px",
                                                                height: "3px",
                                                                backgroundColor: colorMap[props.toSchemeRisk.toLowerCase()],
                                                                alignSelf: "center",
                                                                borderRadius: "50%",
                                                                marginTop: "4px"
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body_500"
                                                            sx={{ color: colorMap[props.toSchemeRisk.toLowerCase()] }}
                                                        >
                                                            {props.toSchemeRisk}
                                                        </Typography>
                                                    </>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box >
                                </Grid>
                            </>)}
                    </Grid>
                </Box>
                {(
                    role === USER_ROLES.INVESTOR &&
                    isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })
                ) && (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center"
                            }}
                        >
                            <Button
                                variant="outlined"
                                sx={(theme: Theme) => ({
                                    ...theme.typography.body_600,
                                    color: theme.palette.primary[500],
                                    border: `1px solid ${theme.palette.primary[500]}`,
                                    borderRadius: "5px",
                                    padding: "5px 23px",
                                    backgroundColor: theme.palette.common.white,
                                })}
                                onClick={() => handleAddToCartClick(props)}
                                disabled={props.status !== "active"}
                            >
                                Add to Cart
                            </Button>
                        </Box>
                    )}
            </Box>
            <Grid
                container
                sx={(theme: Theme) => ({
                    borderBottomWidth: showMoreDetails.length > 0 ? "0px" : "1px",
                    borderBottomStyle: "solid",
                    borderBottomColor: `${theme.palette.text.secondary}B2`
                })}
            >
                {visibleDetails.map(obj => (
                    <Grid
                        key={obj.label}
                        item
                        xs={12}
                        sm={3}
                        sx={{ padding: "20px" }}
                    >
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                marginBottom: '4px',
                                color: theme.palette.text.secondary
                            })}
                        >
                            {obj.label}
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                fontWeight: '600',
                                color: obj?.color ? obj.color : theme.palette.text.primary,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            })}
                        >
                            {obj.value}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
            {toggleShowMore && (
                <Grid container>
                    {showMoreDetails.map(obj => (
                        <Grid
                            key={obj.label}
                            item
                            xs={12}
                            sm={3}
                            sx={{ padding: "20px" }}
                        >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    marginBottom: '4px',
                                    color: theme.palette.text.secondary
                                })}
                            >
                                {obj.label}
                            </Typography>
                            <Typography
                                variant="subtitle_400"
                                sx={(theme: Theme) => ({
                                    fontWeight: '600',
                                    color: theme.palette.text.primary,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                })}
                            >
                                {obj.value}
                            </Typography>
                        </Grid>
                    ))}
                    {props.sipUntilCancelFlag === "Y" && (
                        <Grid item xs={12}>
                            <Box sx={{ mt: 2, px: 2, md: 2 }}>
                                <Notes
                                    displayContent={
                                        'SIP Until Cancelled is Enabled'
                                    }
                                />
                            </Box>
                        </Grid>
                    )}
                </Grid>
            )}
            {showMoreDetails.length > 0 && (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center"
                    }}
                >
                    <Box
                        sx={(theme: Theme) => ({
                            width: '100%',
                            height: '1px',
                            background: theme.palette.textDark.secondary,
                        })}
                    />
                    <IconButton
                        onClick={handleShowMoreToggle}
                        sx={{
                            padding: "0px"
                        }}
                    >
                        {toggleShowMore ? <UpwardToggleBlueIcon /> : <DownwardToggleBlueIcon />}
                    </IconButton>
                    <Box
                        sx={(theme: Theme) => ({
                            width: '100%',
                            height: '1px',
                            background: theme.palette.textDark.secondary,
                        })}
                    />
                </Box>
            )}
        </Box >
    )
}